import { baseLight, basePrimary, blackColor, blueColor, greenColor } from "../styles/graph-colors"
import { TextConfig } from "konva/lib/shapes/Text"


export const TEXT_HEADER_COLOR = basePrimary
export const TEXT_HEADER_COLOR_Counter = blackColor
export const BASE_NODE_COLOR = baseLight
export const NODE_BORDER = 8

export const DEFAULT_NODE_COLOR = baseLight;
export const defaultNodeLineColor = baseLight;

//Node Statuses

export const COMPLETED_STEP_BORDER_COLOR = greenColor
export const COMPLETED_TARGET_BORDER_COLOR = basePrimary
export const CONTRACT_ACTIVE_STEP_COLOR = baseLight
export const CONTRACT_STEP_ERROR_COLOR = blueColor

export const COMPLETED_STEP_BORDER_WIDTH = 1
export const COMPLETED_TARGET_BORDER_WIDTH = 1
export const CONTRACT_ACTIVE_STEP_WIDTH = 1
export const CONTRACT_STEP_ERROR_WIDTH = 1

export const STATUS_ICON_RIGHT_PADDING = 2.5
//export const BP_ACTIVE_STEP_BORDER_WIDTH = 3
//export const TASK_BORDER_RADIUS = 9
export interface IContractNodeStyleConfing {
	icon:{
		iconBackGround:string,
		iconBackGroundHeight:number,
		iconRadius:number,
		iconHeight:number,
	}
	iconGap:number,
	textMain:TextConfig,
	textCounter: TextConfig,
	counterGap:number
}
export interface INodeStyleConfing {
  textMain:TextConfig,
  fronLineWidth?:number
  statusPanel: {
    offsetX:number,
    offsetY:number,
    iconBackGround:string,
    iconBackGroundHeight:number,
    iconRadius:number,
    iconHeight:number,
    toolTipBackGroundColor:string,
    height:number,
    width:number
    align:'left'|'right',
    gap:number,
    tooltip:{
      fontFamily:string,
      fontSize:number,
      fontColor:string,
      backGround:string,
    },
  },
  activeStep: {
    borderColor:string,
    borderWidth:number,
    edgeWidth:number
  }
  avatarPanel:INodeAvatarStyleConfig,
  edgeDeletButton: {
    iconPath:string,
    iconRadius:number,
    iconHeight:number,
    iconBackGroundHeight:number
    iconBackGroundColor:string
    activeIcon:boolean
  }
}
export interface INodeAvatarStyleConfig  {
    offsetX:number,
    offsetY:number,
    gapPanel:number,
    gapAvatar:number,
    borderColor:string,
    borderSize:number,
    avatarRadius:number,
    avatarHeight:number,
    toolTipBackGroundColor:string,
    height:number,
    width:number,
    align:'left'|'right',
    genericAvatar:{
      fontFamily:string,
      fontSize:number,
      fontColor:string,
    }
    tooltip:{
      fontFamily:string,
      fontSize:number,
      fontColor:string,
      backGround:string,
    },
  }
export const TEXT_MODEL = {

    align: 'center',
    fontSize: 14,
    verticalAlign: 'middle',
    fontFamily: 'Onest',
    fill: basePrimary,
    offsetX:-10
}